import { ReactElement } from 'react';

import { reactToWebComponent } from './react-to-web-component';

export const defineWebComponents = (/* istanbul ignore next: default value */ webComponentMap = new Map()) => {
  webComponentMap.forEach((reactElement: ReactElement, webComponentTagName: string) => {
    const webComponentTagsInPage: number = document.getElementsByTagName(webComponentTagName)?.length;
    /* istanbul ignore else */ if (!customElements.get(webComponentTagName) && webComponentTagsInPage !== 0) {
      const webComponentElement = reactToWebComponent(reactElement);
      customElements.define(webComponentTagName, webComponentElement);
      console.info('webComponent defined:', webComponentTagName);
    }
  });
};
